function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299.3 69",
    style: {
      enableBackground: "new 0 0 299.3 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M77.1 58.6s200.2 0 190.5 1.3c-.8.1-149.1.8-185.7 3.8-2.2.2-4.8-5.1-4.8-5.1z",
    style: {
      fill: "#fffcbb"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 137.071,
    y1: 583.71,
    x2: 137.071,
    y2: 542.5,
    gradientTransform: "translate(0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fffcbb"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fffcbd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.9 55.5h3.9l-1.9-31h-5.1l-5.5 15c-1.4 3.9-2.5 7.3-3.3 10.5h-.1c-.8-3.2-1.8-6.6-3.1-10.5l-5.3-15h-5.1l-2.2 31H81l.8-13.3c.3-4.7.5-9.9.6-13.7h.1c.9 3.7 2.1 7.7 3.6 12.1l5 14.8h3l5.5-15.1c1.6-4.3 2.9-8.1 3.9-11.8h.1c-.1 3.9.2 9.1.5 13.4l.8 13.6zm5.9-22.3 8.3 20.5c.1.3.2.7.3 1.1 0 .3-.2.7-.3 1-.8 1.7-1.9 3.3-3.4 4.5-1 .9-2.2 1.6-3.5 2l1 3.4c1.9-.4 3.6-1.3 5-2.6 2.8-2.4 4.7-6.3 7.6-14l6.1-15.9h-4.3l-4.4 13.1c-.6 1.6-1 3.3-1.4 4.7h-.1c-.4-1.3-.9-3.1-1.4-4.5l-4.9-13.2h-4.6zm27.8 22.3V42.3c0-5.2-.1-8.9-.3-12.8h.1c1.7 3.6 3.7 7 5.8 10.4l9.9 15.7h4.1v-31h-3.8v13c0 4.8.1 8.6.5 12.8h-.1c-1.6-3.5-3.5-6.9-5.6-10.1l-10-15.7h-4.3v31l3.7-.1zm43.2-10.4c.1-.6.1-1.3.1-1.9 0-4.1-1.9-10.5-9.2-10.5-6.5 0-10.4 5.3-10.4 12s4.1 11.2 11 11.2c2.5.1 5.1-.4 7.4-1.4l-.7-2.9c-1.9.8-4.1 1.2-6.2 1.2-4 0-7.6-2.3-7.6-7.7h15.6zm-15.6-2.9c.3-2.8 2.1-6.6 6.2-6.6 4.6 0 5.7 4 5.6 6.6h-11.8zm21-14.3v5.3h-3.4v3.1h3.4v12.2c0 2.6.4 4.6 1.6 5.8 1.1 1.2 2.7 1.8 4.4 1.7 1.2 0 2.4-.1 3.6-.5l-.2-3c-.8.2-1.6.3-2.4.3-2.3 0-3-1.6-3-4.3v-12h5.8v-3.2h-5.8v-6.4l-4 1z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 55.4c2.5.3 5.1.4 7.6.4 6 0 11-1.4 14-4.2 2.9-2.7 4.8-6.8 4.8-12.3 0-5.3-1.8-9-4.8-11.4s-6.9-3.6-12.7-3.6c-3 0-6 .2-9 .6l.1 30.5zm5.7-26.4c1.3-.2 2.6-.4 3.9-.3 7.1 0 11.1 3.9 11 10.8 0 7.9-4.4 11.9-11.7 11.9-1 0-2.1 0-3.1-.1l-.1-22.3zm30.1 26.5V33.1h-5.7v22.4h5.7zm-2.9-31.7c-1.7-.1-3.1 1.2-3.2 2.8v.3c0 1.8 1.4 3.2 3.2 3.2 1.8 0 3.2-1.4 3.2-3.2 0-1.7-1.3-3-2.9-3.1h-.3zm25.4 31.7c-.2-1.8-.3-3.6-.3-5.4V42c0-4.9-2.1-9.4-9.3-9.4-2.8-.1-5.6.6-8.1 2l1.1 3.7c1.8-1.1 3.9-1.7 6-1.7 3.9 0 4.6 2.4 4.6 3.9v.4c-8.3 0-13.3 2.8-13.3 8.5 0 3.7 3 6.7 6.6 6.7h.5c2.6.1 5-1 6.6-3h.1l.4 2.5 5.1-.1zm-5.8-7.8c0 .4-.1.8-.2 1.2-.6 1.9-2.4 3.1-4.4 3.1-1.7.1-3.1-1.1-3.2-2.8v-.5c0-3.4 3.8-4.3 7.8-4.2v3.2zm10.4 7.8h5.7V43.9c0-.6.1-1.2.2-1.8.4-2.5 2.5-4.3 5.1-4.3.6 0 1.1.1 1.7.2v-5.3c-.4-.1-.9-.1-1.4-.1-2.9.1-5.3 2-6.1 4.8h-.2l-.2-4.3h-4.9c.1 2 .2 4.2.2 7.2l-.1 15.2zm13.9-22.4 8.2 20.6c.2.3.3.7.3 1.1 0 .4-.2.7-.4 1-.7 1.4-1.8 2.6-3.1 3.5-1 .7-2.1 1.3-3.3 1.6l1.3 4.8c2.2-.4 4.3-1.4 5.9-2.9 2.7-2.3 4.7-6 7.8-14.4l5.6-15.3H293l-3.5 12c-.4 1.5-.8 3.1-1.2 4.4h-.1c-.3-1.3-.8-3-1.2-4.4l-4-12h-6.2z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 29.201,
    y1: 585.5,
    x2: 29.201,
    y2: 534.44,
    gradientTransform: "translate(0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c9f94f"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#dafc6d"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42 33.8c-12.8 5.9-26.6 9.5-40.7 10.5H.6c-.1-.8-.2-1.7-.2-2.6 0 0-2.2-22.1 13.3-25.8 0 0 4.7-1.7 10.2 1.6 1.6.8 3.3 1.2 5 1.4 2 .2 4-.1 5.9-.9h-.1c.7-.3 1.1-.5 1.1-.5 5.6-3.3 10.2-1.6 10.2-1.6 4.8 1.1 8.8 4.5 10.7 9.1l-.7.6c-4.4 3.2-9.1 5.9-14 8.2zm1 22.1c5.4-2 10.5-4.6 15.2-7.7-2.3 8.1-7.5 15-14.7 19.3-4.3 2.8-9.9.9-9.9.9-1.3-.4-2.7-.6-4-.8-1.3.2-2.7.5-4 .8 0 0-5.5 1.9-9.9-.9-2.2-1.3-4.2-2.9-6-4.7 11.5-.6 22.6-2.9 33.3-6.9z",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 561.361,
    x2: 61.176,
    y2: 561.361,
    gradientTransform: "translate(0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f9f6e5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9f6e5"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60.7 44.7C46.3 55.5 26.7 60.2 9 61.4c-.3 0-.6-.1-.8-.4C7 59.3 2.1 52.6.1 47.3c-.3-.7 0-1.3.8-1.9-.2.3-.4.9.2.9 17.7-1.9 40.2-7.3 56.2-19.4.4-.2.5-.8.2-1.1-.1-.2-.3-.3-.5-.3 0 0 1.6 0 2.1.9s2 11.6 2.1 17.6c0 .1-.2.5-.5.7z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.3 49.3-1 .2-1.2 1.1.5 1 .8-.7 1.1 4.5 1.2-.2-1.4-5.9zm15.3 2-2 .6c.8-1.3 1.4-2.5 1.1-3.6-.2-.9-1-1.5-1.9-1.4-.2 0-.3 0-.5.1-.6.1-1.2.5-1.6 1l-.1.2.7.9.2-.3c.2-.3.5-.5.9-.7.4-.1.8 0 1 .4v.2c.2.7-.2 1.5-1.2 3.2l-.5.8.2.7 4-1-.3-1.1zm12.6-4.1c-.2-.6-.7-1-1.3-1.2.5-.7.4-1.7-.3-2.2-.3-.2-.6-.3-1-.3-.3 0-.5 0-.7.1-.6.2-1.1.5-1.4 1l-.1.2.7.9.2-.3c.2-.3.5-.5.8-.6.1 0 .2-.1.3-.1.2 0 .5.2.5.4.1.2 0 .4-.1.6-.2.2-.4.3-.6.4l-.7.2.3 1 .7-.2c.2-.1.4-.1.6-.1.4 0 .7.2.8.5.1.2.1.4 0 .6-.1.2-.4.4-.7.5-.2.1-.4.1-.7.1-.2 0-.3 0-.5-.1l-.3-.1v1.2l.2.1c.2.1.4.1.6.1.3 0 .7-.1 1-.2.6-.2 1.1-.5 1.5-1.1.3-.3.4-.9.2-1.4 0 .1 0 0 0 0zm11.9-4.4-.4-1.1-.7.4-1.3-3.3-1.2.4-1.1 4.5.3.8 2.4-.9.5 1.4 1.2-.5-.5-1.4.8-.3zm-3.3.1.5-1.8.5 1.4-1 .4zm13.6-5.6c-.3-.6-.9-1.1-1.6-1.1-.5 0-.9.1-1.4.3l-.1.1-.3-.8 2-.9-.5-1.1-2.9 1.4 1 3.1.4-.3.6-.3c.3-.1.5-.2.8-.2.4 0 .7.2.8.5.2.5 0 1.1-.5 1.3-.3.1-.6.2-.9.2h-.5l.1 1.1h.5c.4 0 .8-.1 1.2-.3.6-.3 1-.7 1.3-1.3.2-.5.2-1.2 0-1.7zM10.2 56.9 9 57l1.3 4.2 1.2-.1-1.3-4.2zm12.7-2.1-1.2.2 1.2 4.7 1.2-.2-1.2-4.7zm13-3.2-1.2.4 1.5 4.7 1.2-.4-1.5-4.7zm12.3-4.5-1.2.5 1.7 4.2 1.1-.5-1.6-4.2zm10.2-5.2-1.1.7 1.2 3.7c.3-.2.7-.5 1-.7l-1.1-3.7zM17.3 58.4l-1.3.2.6 2 1.2-.2-.5-2zm25.8-6.6-1.1.4.8 2.1 1.1-.5-.8-2zm-12.6 3.8-1.2.3.7 2.3 1.2-.3-.7-2.3zm24-9.3c-.3.2-.8.4-1.1.6l.7 2.1c.4-.2.7-.4 1.1-.6l-.7-2.1z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 30.181,
    y1: 537.894,
    x2: 44.187,
    y2: 516.482,
    gradientTransform: "translate(0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#b3f42b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#c5fa57"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 17S29.8 4 43.4 0c.1 0 2.4 12-11.4 17z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: 26.885,
    y1: 535.023,
    x2: 25.555,
    y2: 524.453,
    gradientTransform: "translate(0 -518)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#db9948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#e6a14b"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4 17.1s-2.1-6.1-6.2-7.7l4.5-3.3c2.7 3.1 3.9 7.2 3.5 11.3-.6.1-1.2 0-1.8-.3z",
    style: {
      fill: "url(#e)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/logo-main.9fc46224e74830f8c77ba78ad7f7faa5.svg";
export { ForwardRef as ReactComponent };